import Image from "next/image";
import React, { useState } from "react";
import styles from "./Login.module.css";
import Local from "../../ImageLoader";
import Link from "next/link";
import { useTranslation } from "../../../context/TranslationContext";
import { renderToString } from "react-dom/server";
import ReservationLoginForm from "./ReservationLoginForm";
import MemberLoginForm from "./MemberLoginForm";

const Login = ({ checkLogin, ssr }) => {
  const [activeTab, setActiveTab] = useState("reservation"); // "reservation" or "member"
  const { ContactPage } = ssr.result;
  const {
    loginRightDescription,
    loginRightDescriptionContactLink,
    loginLeftSubtitle,
    loginLeftTitle,
    loginLeftCopyRight,
    welcome,
    loginSuccess,
    loginFormEmail,
    loginReservationNumber,
    login,
    loginRightDescriptionBottom,
    rezervationCode,
    memberLogin,
  } = useTranslation();

  const ContactLink = () => {
    return (
      <Link href={ContactPage.url}>
        <a className="text-information-color2 border-b border-information-color2">
          {loginRightDescriptionContactLink}
        </a>
      </Link>
    );
  };

  return (
    <>
      <div className="flex flex-wrap lg:h-full bg-white">
        <div className="lg:w-[52.5%] w-full xl:mb-0 mb-5 ">
          <div className="w-full h-64 lg:h-full relative">
            <Image
              src={"/images/villas-wealper.jpg"}
              loader={Local}
              layout="fill"
              className="object-cover w-full h-full"
              alt="Rezervasyonlarım"
            />

            <div className={`absolute top-1/3 ${styles.leftSpace}`}>
              <div className="flex flex-col">
                <span className="font-semibold text-[22px] lg:leading-8 text-white">
                  {loginLeftSubtitle}
                </span>
                <span className="font-bold md:text-[40px] text-[35px] lg:leading-[55px] text-white">
                  {loginLeftTitle}
                </span>
              </div>
            </div>
            <div className={`absolute bottom-0 mb-9 ${styles.leftSpace}`}>
              <span className="font-semibold text-[12px] leading-4 text-white">
                {loginLeftCopyRight}
              </span>
            </div>
          </div>
        </div>
        <div className="lg:w-[47.5%] w-full h-full lg:pl-20 pl-3 lg:pb-0 pb-20">
          <div className="xl:w-[500px] xl:pr-0 pr-3 h-full flex flex-col items-center justify-center">
            <div className="flex flex-col mb-10 w-full">
              <span className="font-bold text-[14px] leading-[19px] text-information-color2">
                {loginLeftTitle}
              </span>
              <span className="font-bold text-[#333738] text-[30px] leading-10 mb-[14px]">
                {welcome}
              </span>
              <span
                className="font-medium text-13 leading-6 text-[#A2B2B8] mb-6"
                dangerouslySetInnerHTML={{
                  __html: loginRightDescription.replace(
                    "{contact}",
                    renderToString(<ContactLink />),
                  ),
                }}
              ></span>

              <div className="flex border-b border-[#dee9ed] mb-8">
                <button
                  onClick={() => setActiveTab("reservation")}
                  className={`pb-4 px-4 text-sm font-bold transition-all ${
                    activeTab === "reservation"
                      ? "text-product-type-color border-b-2 border-product-type-color"
                      : "text-[#A2B2B8] hover:text-[#333738]"
                  }`}
                >
                  {rezervationCode}
                </button>
                <button
                  onClick={() => setActiveTab("member")}
                  className={`pb-4 px-4 text-sm font-bold transition-all ${
                    activeTab === "member"
                      ? "text-product-type-color border-b-2 border-product-type-color"
                      : "text-[#A2B2B8] hover:text-[#333738]"
                  }`}
                >
                  {memberLogin}
                </button>
              </div>
            </div>

            {activeTab === "reservation" ? (
              <ReservationLoginForm
                loginFormEmail={loginFormEmail}
                loginReservationNumber={loginReservationNumber}
                login={login}
                loginSuccess={loginSuccess}
                checkLogin={checkLogin}
              />
            ) : (
              <MemberLoginForm checkLogin={checkLogin} />
            )}

            <div className="bg-[#fcf4f4] border border-[#f2dcdc] rounded p-4">
              <span className="font-medium text-13 leading-6 text-[#d20000]">
                {loginRightDescriptionBottom}
              </span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
